module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"close":"Schließen","details":"Details","deals":"Angebote","menu":"Speisekarte","hours":"Öffnungszeiten","contact":"Kontakt","specialFacts":"Special Facts","share":"Teilen"},"en":{"close":"Close","details":"Details","deals":"Deals","menu":"Menu","hours":"Hours","contact":"Contact","specialFacts":"Special Facts","share":"Share"}}')
  delete Component.options._Ctor
}
